<script setup lang="ts">
import type { NavTypes } from '../components/AppSideMenu.vue'

const init3 = useInited('init3')
const props = defineProps<{ active?: NavTypes; nav: boolean }>()
const active2 = computed(() => props.active ?? 'info')
const mobile = useMobile()
</script>

<template>
  <div :class="[$style.split, { nav }]" class="_pb8">
    <slot />

    <LazyAppMenuContMobileMenu v-if="mobile && init3">
      <AppSideMenuUser v-if="active2 === 'user'" />
      <AppSideMenuInfo v-else />
    </LazyAppMenuContMobileMenu>

    <section v-memo="[active2]" :class="[$style.b, $clsClass('menu')]" :style="mobile && 'min-height: 1050px'">
      <div :class="$style.b2">
        <div v-if="mobile">
          <AppSideMenuUser v-if="active2 === 'user'" />
          <AppSideMenuInfo v-else />
        </div>

        <AppSideMenu v-else :active="active2" />
      </div>
    </section>
  </div>
</template>

<style module>
.split {
  composes: global(_hm100p);
  composes: global(m_w100p);

  composes: global(_grid);
  grid-template-columns: minmax(70%, 1fr) minmax(30%, 490px);
}
:global(.m) .split {
  grid-template-columns: minmax(0, 1fr);
  padding-top: calc(var(--nav-h) + 10px);
}
.b {
  composes: global(_relative);
  composes: global(_row);
  composes: global(m_pt4);
  composes: global(m_pl04);
  composes: global(m_pr04);
  composes: global(d_hm100vh);
  composes: global(_w100p);

  composes: global(_pt8);
  composes: global(_pb3);
  composes: global(_pl3);

  border-bottom-left-radius: 14px;
}
:global(.m) .b {
  grid-row: 0;
}
.b2 {
  composes: global(d_sticky);
  composes: global(m_w100p);
  composes: global(d_hm100vh);
  composes: global(d_pb4);
  composes: global(d_pt2);
  composes: global(d_wmax);
}
:global(.d) .b2 {
  bottom: 0;
  align-self: flex-end;
}
</style>
